'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _components2 = require('components');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Passenger = function Passenger(_ref) {
    var requiredApiCalls = _ref.requiredApiCalls,
        passengersById = _ref.passengersById,
        params = _ref.params,
        updateUI = _ref.updateUI,
        ui = _ref.ui,
        children = _ref.children;
    return _react2.default.createElement(
        _components2.LoadingIndicator,
        {
            apiCalls: requiredApiCalls,
            mustExist: [{
                value: passengersById[params.passengerId],
                error: 'The customer in the url does not exist for this booking.'
            }] },
        passengersById[params.passengerId] && _react2.default.createElement(
            'div',
            {
                onClick: function onClick() {
                    if (ui.passengersDropdownIsVisisble) {
                        updateUI('passengersDropdownIsVisisble', false);
                    }
                }
            },
            _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo' },
                    _react2.default.createElement('img', { src: require('theme/img/g_logo.svg'), alt: 'Good To Go Trademark', title: 'Good To Go' })
                ),
                _react2.default.createElement(_components2.TravellerTitle, {
                    className: 'TravellerTitle',
                    name: passengersById[params.passengerId].name
                }),
                _react2.default.createElement(_components2.NavWithNamelist, {
                    className: 'NavWithNamelist',
                    passengerId: params.passengerId,
                    showRequirements: params.requirementSet,
                    passengersById: passengersById
                }),
                children
            )
        )
    );
};
Passenger.propTypes = {
    requiredApiCalls: _propTypes2.default.array.isRequired,
    passengersById: _propTypes2.default.object.isRequired,
    params: _propTypes2.default.shape({
        passengerId: _propTypes2.default.string.isRequired,
        requirementSet: _propTypes2.default.string
    }),
    updateUI: _propTypes2.default.func.isRequired,
    ui: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.object.isRequired
};

exports.default = (0, _reduxUi2.default)()((0, _pacomo.pacomoTransformer)(Passenger));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/Passenger/Passenger.js
// module id = 1305
// module chunks = 0